import { observer } from 'mobx-react-lite';

import type { EditableNodeDefinition } from '../../edit/EditableNodeDefinition';
import Handles from '../ui/Handles';

/**
 * The `conditions` node type's Definition-tab editor: just its condition handles. Model-bound — the same `handles` Aggregate
 * the Properties tab edits, so the two views stay in sync.
 */
const Conditions = observer(({ entity }: { readonly entity: EditableNodeDefinition }) => <Handles entity={entity} />);

export default Conditions;
